import React from 'react';
import { Card, Skeleton, Table, Row, Col } from 'antd';

interface SkeletonLoaderProps {
  tierCount?: number;
  isMobile: boolean;
  columns?: any[];
}

export const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ tierCount = 3, isMobile, columns = [] }) => {
  const renderSkeletonMobileCard = () => (
    <Card size="small" style={{ marginBottom: 12 }}>
      <div style={{ marginBottom: 12 }}>
        <Skeleton.Input active size="default" style={{ width: 150, height: 20, marginBottom: 8 }} />
        <Skeleton.Input active size="small" style={{ width: 100, height: 16 }} />
      </div>
      <Row gutter={[8, 8]}>
        {[...Array(8)].map((_, idx) => (
          <Col span={12} key={idx}>
            <Skeleton.Input active size="small" style={{ width: '100%', height: 12, marginBottom: 4 }} />
            <Skeleton.Input active size="default" style={{ width: '80%', height: 16 }} />
          </Col>
        ))}
      </Row>
    </Card>
  );

  const renderSkeletonTable = () => {
    const skeletonRows = 5;

    return (
      <div>
        <Table
          columns={columns.map((col) => ({
            ...col,
            render: () => (
              <div
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: col.align === 'right' ? 'flex-end' : 'flex-start',
                }}
              >
                <Skeleton.Input active size="small" style={{ width: '80%', minWidth: 60 }} />
              </div>
            ),
          }))}
          dataSource={Array.from({ length: skeletonRows }, (_, i) => ({ key: i }))}
          pagination={false}
          size="small"
          scroll={{ x: 'max-content' }}
        />
      </div>
    );
  };

  return (
    <>
      {/* Period card skeleton */}
      <Card style={{ marginBottom: 16 }}>
        <Skeleton.Input active size="default" style={{ width: 200, height: 20 }} />
      </Card>

      {/* Tier cards skeleton */}
      {Array.from({ length: tierCount }).map((_, tierIdx) => (
        <Card
          key={`skeleton-tier-${tierIdx}`}
          title={
            <div>
              <Skeleton.Input active size="large" style={{ width: 200, height: 24, marginBottom: 8 }} />
              <Skeleton.Input active size="small" style={{ width: 300, height: 16 }} />
            </div>
          }
          style={{ marginBottom: 24 }}
        >
          {isMobile ? (
            <div>
              {Array.from({ length: 3 }).map((_, idx) => (
                <div key={`skeleton-mobile-${tierIdx}-${idx}`}>{renderSkeletonMobileCard()}</div>
              ))}
              {/* Average card skeleton */}
              <Card size="small" style={{ marginTop: 8, backgroundColor: '#f5f5f5', border: '2px solid #d9d9d9' }}>
                <div style={{ marginBottom: 8 }}>
                  <Skeleton.Input active size="default" style={{ width: 80, height: 20 }} />
                </div>
                <Row gutter={[8, 8]}>
                  {[...Array(8)].map((_, idx) => (
                    <Col span={12} key={idx}>
                      <Skeleton.Input active size="small" style={{ width: '100%', height: 12, marginBottom: 4 }} />
                      <Skeleton.Input active size="default" style={{ width: '80%', height: 16 }} />
                    </Col>
                  ))}
                </Row>
              </Card>
            </div>
          ) : (
            renderSkeletonTable()
          )}
        </Card>
      ))}
    </>
  );
};

